import React from 'react';
import i18next from 'i18next';
import Container from '../../StyledComponents/Container';
import { Page, PageSection } from '../../StyledComponents/Page';
import { H1 } from '../../StyledComponents/Heading';

const Page404 = () => (
  <Page>
    <PageSection large>
      <Container>
        <H1 noMargin>{i18next.t('other.error404')}</H1>
      </Container>
    </PageSection>
  </Page>
);

export default Page404;
